import { defineMessages } from 'react-intl';

export default defineMessages({
    drivers: {
        id: 'ml.quoteandbind.pa.quote.driverTable.drivers',
        defaultMessage: 'Drivers'
    },
    addDriver: {
        id: 'ml.quoteandbind.pa.quote.driverTable.addDriver',
        defaultMessage: 'ADD DRIVER'
    },
    excludedDrivers: {
        id: 'ml.quoteandbind.pa.quote.driverTable.excludedDrivers',
        defaultMessage: 'Excluded Drivers'
    },
    excludedDriversSubtitle: {
        id: 'ml.quoteandbind.pa.quote.driverTable.excludedDriversSubtitle',
        defaultMessage: 'These are excluded drivers living at your physical address'
    },
    addExclDriver: {
        id: 'ml.quoteandbind.pa.quote.driverTable.addExclDriver',
        defaultMessage: 'ADD EXCLUDED DRIVER'
    },
    exclDriverHelpTitle: {
        id: 'ml.quoteandbind.pa.quote.driverTable.exclDriverHelpTitle',
        defaultMessage: 'What does this mean?'
    },
    exclDriverHelpDesc: {
        id: 'ml.quoteandbind.pa.quote.driverTable.exclDriverHelpDesc',
        defaultMessage: 'The driver will be excluded from liability coverage under this policy.'
    },
    householdMembers: {
        id: 'ml.quoteandbind.pa.quote.driverTable.householdMembers',
        defaultMessage: 'Household Members'
    },
    householdMembersSubtitle: {
        id: 'ml.quoteandbind.pa.quote.driverTable.householdMembersSubtitle',
        defaultMessage: 'The following people live in your household but do not drive or have other insurance'
    },
    addHouseholdMembers: {
        id: 'ml.quoteandbind.pa.quote.driverTable.addHouseholdMembers',
        defaultMessage: 'ADD HOUSEHOLD MEMBER'
    },
    nonDrivers: {
        id: 'ml.quoteandbind.pa.quote.driverTable.nonDrivers',
        defaultMessage: 'Non Drivers'
    },
    addNonDriver: {
        id: 'ml.quoteandbind.pa.quote.driverTable.addNonDriver',
        defaultMessage: 'ADD NON DRIVER'
    },
    nonDriversSubtitle: {
        id: 'ml.quoteandbind.pa.quote.driverTable.nonDriversSubtitle',
        defaultMessage: 'The following people are non drivers that do not driver or have other insurance'
    }
});
